import React from 'react';

import Defaults from '../../../shared/constants/defaults';
import FormSettings from '../../../shared/constants/form-settings';

import SelectMenuComponent from '../../../../../../common/react/components/select-menu';

export default class EdlioPayPayment extends React.Component {
	constructor (props) {
		super(props);

		let settings = this.props.formData.settings;
		let savedGlAccount = settings[FormSettings.GL_ACCOUNT] ? settings[FormSettings.GL_ACCOUNT] : Defaults.NO_ACCOUNT;

		this.glAccounts = (window.edlio.glAccounts ? window.edlio.glAccounts : []);
        const index = this.glAccounts.indexOf(Defaults.NO_ACCOUNT);
        if (index > -1) {
          this.glAccounts.splice(index, 1);
        }
        this.glAccounts.unshift(Defaults.NO_ACCOUNT);

		this.state = {
			selectedGlAccount: savedGlAccount
        };
	}

	getGlAccounts() {
		let accountLabels = [];

		accountLabels.push(...this.glAccounts.map(acc => {
		        return {
                    label: acc,
                    callback: () =>
                        this.setState({selectedGlAccount: acc}, () => this.props.updateCallback(FormSettings.GL_ACCOUNT, acc))
                }
            }
        ));

		return accountLabels;
	}

	render() {

		let { localization } = this.props;

		return (
            <section>
                <p>{localization.substitute('Associate this form to a fund account to see them in the payout statement.')}</p>
                <p>{localization.substitute('Account cannot be changed after receiving a form response.')}</p>
                <div>
                <h3>{localization.substitute('GL/Revenue Account')}</h3>
                {
                    window.edlio.isAdmin ? (<span className={"note"}>{localization.substitute('Add accounts in ')} <a href="/apps/settings/admin_index.jsp?tid=31">{localization.substitute('Settings')}</a></span>)
                    : (<span className={"note"}>{localization.substitute('Website administrators can manage accounts in Settings')}</span>)
                }
                <br/>
                <SelectMenuComponent
                    additionalClasses={this.glAccounts.length ? null : 'disabled'}
                    options={this.getGlAccounts()}
                    selectedOption={this.state.selectedGlAccount}
                    disabled={this.props.formData.entries.count > 0 }
                />
                </div>
            </section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/sections/edlio-pay-payment.js